// import { loginState } from 'Store'
import { constants, accessObjectUsingString } from 'Utils'

const scalingFactor = 0.8

export default {
  data: function () {
    return {
      APP_API_URL: process.env.VUE_APP_API_URL,
      $scalingFactor: scalingFactor
    }
  },
  computed: {
    $globalSideMargin() {
      if (this.$breakpoints.smAndDown) {
        return '36px'
      }
      return this.$getScaledCssValue('220px')
    },
    $globalSideMarginNumber() {
      if (this.$breakpoints.smAndDown) {
        return 36
      }
      return this.$getScaledValue(270)
    },
    $breakpoints() {
      return this.$vuetify.breakpoint
    },
    // Just an estimate since small app bar height is auto
    $smallAppBarHeight() {
      return '165px'
    },
    $constants() {
      return constants
    },
    $maxWidth() {
      return '1280px'
    },
    $markFontFamily() {
      return 'Mark Offc For MC'
    }
  },
  methods: {
    /**
     * Checks if the currently logged in user has the appropriate permissions to perform
     * an action. The user's permissions are stored in state
     * @param {string} permissionName
     * @returns {Boolean}
     */
    // $can(permissionName) {
    //   const userPermissions = loginState.userPermissions
    //   if (userPermissions) {
    //     return userPermissions.indexOf(permissionName) !== -1
    //   } else {
    //     return false
    //   }
    // },

    /**
     * Checks if the currently logged in user has the required role to perform an action.
     * The user's roles are stored in state
     * @param {string} roleName
     * @returns {Boolean}
     */
    // $hasRole(roleName) {
    //   const userRoles = loginState.userRoles
    //   if (userRoles) {
    //     return userRoles.indexOf(roleName) !== -1
    //   } else {
    //     return false
    //   }
    // },

    $capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() +
        string.slice(1)
    },

    $lowerCaseFirstLetter(string) {
      return string.charAt(0).toLowerCase() +
        string.slice(1)
    },

    /**
     * Scrolls to an element
     *
     * @param {Element} element
     */
    $scrollToElement(element) {
      element.scrollIntoView({ behavior: 'smooth' })
    },

    /**
     * Scrolls to the first element with an error that is a child of
     * this.$refs.formElement
     */
    $scrollToError() {
      this.$nextTick(() => {
        const el = this.$refs.formElement
          .querySelector('.v-messages.error--text:first-of-type')
          .closest('.v-input')
        if (el) {
          this.$scrollToElement(el)
        }
      })
    },

    /**
     * Loads an image from a file into an image element
     *
     * @param {string} file The file from which to load the image
     * @param {Element} imageElement The image element into which the image will be loaded
     *
     * @returns {void}
     */
    $loadImageFromFile(file, imageElement) {
      if (file && file.type.startsWith('image/')) {
        imageElement.file = file

        const reader = new FileReader()
        reader.onload = (function (aImg) {
          return function (e) {
            aImg.src = e.target.result
          }
        })(imageElement)
        reader.readAsDataURL(file)
      } else {
        imageElement.src = ''
      }
    },

    /**
     * Extracts values from filter fields and returns an object containing the values
     * @param {Object} filterConfig - The filter config from which values will be extracted
     * @return {Object}
     */
    $getFilterValuesFromFilterConfig(filterConfig) {
      const filterValues = {
        relationValues: {}
      }

      if (filterConfig.relationFields) {
        filterConfig.relationFields.forEach((field) => {
          filterValues.relationValues[field.name] = field.value
        })
      }

      return filterValues
    },

    /**
     * Checks all filter values to see if at least one is set
     * @param {Object} filterValues - The object containing the filter values
     * @returns {boolean}
     */
    /**
     * Was computed property
     */
    $atLeastOneFilterActive(filterValues) {
      for (const filter of Object.values(filterValues)) {
        if (Array.isArray(filter.value) && filter.value.length !== 0) {
          return true
        } else if (!Array.isArray(filter.value) && (filter.value !== 0 || filter.value)) {
          return true
        }
      }

      return false
    },

    /**
     * Sets all filter values to an empty value
     * @param {Object} filterValues - The object containing the filter values
     */
    $clearAllFilters(filterValues) {
      for (const filter of Object.values(filterValues)) {
        if (Array.isArray(filter.value)) {
          filter.value.splice(0)
        } else if (typeof filter.value === 'string') {
          filter.value = ''
        }
      }
    },

    $setFormModels(data, crudConfig) {
      const rowData = {}
      jQuery.extend(true, rowData, data)

      if (crudConfig.formModels) {
        this.formModels = crudConfig.formModels
      } else {
        this.formModels = {}
      }

      if (crudConfig.addIdToRequestBody && rowData.id) {
        this.formModels.id = rowData.id
      }

      crudConfig.fieldsConfig.fields.forEach(async (field) => {
        let dataItem

        /**
         * If the field has a dataKey property, use the value of that property to access rowData.
         * dataKey is used to access nested values using dot syntax but we still want
         * the formModels property to be set to the field's name
         */
        if (field.dataKey) {
          dataItem = accessObjectUsingString(field.dataKey, rowData)
        } else {
          dataItem = rowData[field.name]
        }

        /**
         * If the field has an associated row value, set the field's model value
         * to the row value
         */
        if (dataItem || dataItem === 0) {
          /**
           * If the field has a transformValue function, run the function and set
           * the field's value to the result
           */
          if (typeof field.transformValue === 'function') {
            const transformedData = await field.transformValue(dataItem)
            this.$set(this.formModels, field.name, transformedData)
          }

          /**
           * If value is an array and contains objects, extract the id's from
           * the objects into an array and use that array as the model value
           */
          else if (field.dataTransform !== false &&
            Array.isArray(dataItem) && typeof dataItem[0] === 'object') {
            const newDataItem = dataItem.map((item) => item.id)
            this.$set(this.formModels, field.name, newDataItem)
          } else {
            /**
             * Otherwise just set the field's model value to the row value
             */
            this.$set(this.formModels, field.name, dataItem)
          }
        } else {
          /**
           * If the field has no associated row value, use the field's initial value
           */
          this.$set(
            this.formModels,
            field.name,
            field.initialValue || field.initialValue === null || field.initialValue === 0 ? field.initialValue : ''
          )
        }
      })
    },

    /**
    * Convert the data into a format suitable for a select component
    */
    $getSelectArray(data, textName, valueName) {
      return data.map(item => ({
        text: item[textName],
        value: item[valueName]
      }))
    },

    $getUrlFromCrudConfig(config, mode, id = null) {
      let url = null

      if (config.urlToUse) {
        url = config.urlToUse(config, mode)
      }

      let temp

      switch (mode) {
        case constants.CREATE:
          return url || config.createUrl || config.baseUrl

        case constants.UPDATE:
          return url ? (config.addIdToRequestBody ? url : `${url}/${id}`) : null ||
            config.updateUrl ? (config.addIdToRequestBody ? config.updateUrl : `${config.updateUrl}/${id}`) : null ||
              config.addIdToRequestBody ? config.baseUrl : `${config.baseUrl}/${id}`

        case constants.DELETE:
          return url ? `${url}/${id}` : null ||
            config.deleteUrl ? (config.addIdToRequestBody ? config.deleteUrl : `${config.deleteUrl}/${id}`) : null ||
              config.addIdToRequestBody ? config.baseUrl : `${config.baseUrl}/${id}`
      }
    },

    $scrollToAnchor(selector) {
      const element = document.querySelector(selector)
      if (element) {
        element.scrollIntoView({
          //  behavior: "smooth"
        })
      }
    },

    $getEmptyObject(length) {
      const obj = {}
      const arr = [...Array(length).keys()]
      arr.forEach((key) => {
        obj[key] = null
      })
      return obj
    },

    $getArrayOfEmptyObjects(numberOfItems, objectLength) {
      const arr = [];

      [...Array(numberOfItems).keys()].forEach(() => {
        const obj = {};
        [...Array(objectLength).keys()].forEach((key) => {
          obj[key] = null
        })
        arr.push(obj)
      })

      return arr
    },

    $isObjectEmpty(obj) {
      if (Object.values(obj).length <= 0) {
        return true
      } else {
        return false
      }
    },

    $getScaledCssValue(...value) {
      return value.map(val => `calc(${val} * ${scalingFactor})`).join(' ')
    },

    $getScaledValue(value) {
      return value * scalingFactor
    },

    $formatUnderscoreText(text) {
      const regex = /_/g
      text = text
        .replace(regex, ' ')
        .toLowerCase()
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.substring(1))
        .join(' ')
      return text
    },

    $formatCamelCaseText(text) {
      const regex = /[A-Z]/g
      text = text
        .replace(regex, ' ' + '$&')
        .toLowerCase()
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.substring(1))
        .join(' ')

      return text
    },

    $generateWebsiteLink(link) {
      const regex = new RegExp('http', 'i')
      if (!regex.test(link)) {
        return 'http://' + link
      } else {
        return link
      }
    },

    /**
     * Applies breakpoints to received style objects
     * @param  {...Object} styleObjects - A number of style objects, currently supports 2
     * @returns {Object[]} styleObjects with breakpoints applied
     */
    $applyStyleBreakpoints(...styleObjects) {
      return styleObjects.map((styleObject, index) => {
        if (index == 0) {
          return styleObject
        }

        if (index == 1) {
          return this.$breakpoints.mdAndUp && styleObject
        }
      })
    },

    /**
     * Applies breakpoints to class strings
     * The first string is always applied, the second string gets applied when the small breakpoint
     * is true and the third string gets applied when the large breakpont is true.
     * @param  {...string} classStrings - A number of class strings, currently supports 3
     * @returns {any[]} An array of strings and false (where breakpoints failed)
     */
    $applyClassBreakpoints(...classStrings) {
      return classStrings.map((classString, index) => {
        if (index == 0) {
          return classString
        }

        if (index == 1) {
          return this.$breakpoints.smAndDown && classString
        }

        if (index == 2) {
          return this.$breakpoints.mdAndUp && classString
        }
      })
    },

    $notNullAndUndefined(item) {
      if (item !== null && item !== undefined) {
        return true
      }
      return false
    },

    $getFontProperties({ family = this.$markFontFamily, style = "normal",
      weight = null, size = null, lineHeight = null,
      letterSpacing = null, color = null,
      applyScale = !this.$breakpoints.smAndDown }) {
      const shouldApplyScale = (value) => {
        if (applyScale) {
          return this.$getScaledCssValue(value)
        }
        return value
      }

      return {
        fontFamily: family,
        fontStyle: style,
        fontWeight: shouldApplyScale(weight),
        fontSize: shouldApplyScale(size),
        lineHeight: shouldApplyScale(lineHeight),
        letterSpacing: shouldApplyScale(letterSpacing),
        color: color
      }
    },

    $arrayNotEmpty(array) {
      if (Array.isArray(array) && array.length > 0) {
        return true
      } else {
        return false
      }
    }
  }
}
